import { BaseApiService } from "./BaseApiService";
import {
  IApiResponse,
  IGetAllProductLotsRequest,
  IGetAllProductionPlansRequest,
  IImportProductionPlanRequest,
  IPaginateApiResponse,
  IProductionPlan,
} from "model";
import { PREFIX } from "./common";

export const prefix = PREFIX.productionPlan;

const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};
const URL_GET_ALL_PRODUCTION_PLANS = getUrl("get-all-production-plans");
const URL_GET_PRODUCT_LOT = getUrl("get-product-lots");
const URL_IMPORT_PRODUCTION_PLAN = getUrl("import-production-plan");
const URL_PRODUCTION_PLAN_BY_PRODUCTLOT = getUrl(
  "get-production-plans-by-product-lot"
);
const URL_PRODUCTION_PLAN_BY_MANUFACTURING_DATE = getUrl(
  "get-production-plans-by-manufacturing-date"
);
class ProductionPlanApiService extends BaseApiService {
  public getAllProductionPlan = (request: IGetAllProductionPlansRequest) =>
    this.get<IPaginateApiResponse<IProductionPlan>>(
      URL_GET_ALL_PRODUCTION_PLANS,
      { params: request }
    );
  public getProductionPlanByProductLot = (
    request: IGetAllProductionPlansRequest
  ) =>
    this.get<IPaginateApiResponse<IProductionPlan>>(
      URL_PRODUCTION_PLAN_BY_PRODUCTLOT,
      { params: request }
    );
  public getAllProductionPlanByManufacturingDate = (
    request: IGetAllProductionPlansRequest
  ) =>
    this.get<IPaginateApiResponse<IProductionPlan>>(
      URL_PRODUCTION_PLAN_BY_MANUFACTURING_DATE,
      { params: request }
    );

  public importProductionPlan = (request: IImportProductionPlanRequest) =>
    this.postForm<IImportProductionPlanRequest, IApiResponse<any>>(
      URL_IMPORT_PRODUCTION_PLAN,
      request
    );
  public getAllProductLots = (request: IGetAllProductLotsRequest) =>
    this.get<IPaginateApiResponse<string[]>>(
      URL_GET_PRODUCT_LOT,
      { params: request }
    );
}

export default new ProductionPlanApiService();
